<template>
  <div class="nav-container">
    <!-- 左侧导航栏 -->
    <div class="sidebar">
      <div class="logo">
        <div class="user-info">
          <div class="user-dropdown" @click="toggleDropdown">
            <h4>你好，{{ loginUser.nickName }}</h4>
            <span class="dropdown-arrow">▼</span>
          </div>
          <div v-if="showDropdown" class="dropdown-menu">
            <div class="dropdown-option">
              <span>用户名：{{ loginUser.userName || '用户' }}</span>
            </div>
            <div class="dropdown-item" @click="changePassword">
              修改密码
            </div>
            <div class="dropdown-item logout-item" @click="logout">
              退出系统
            </div>
          </div>
        </div>
      </div>
      <ul class="nav-menu">
        <li v-for="(item, index) in navItems" :key="`nav-item-${index}`" :class="{ active: currentIndex === index }"
          @click="navigateTo(item, index)">
          {{ item.name }}
        </li>
      </ul>
    </div>

    <!-- 右侧内容区域 - 使用router-view展示路由组件 -->
    <div class="main-content">
      <!-- <div class="page-header">
        <h2>{{ currentTitle }}</h2>
      </div> -->
      <div class="page-container">
        <router-view />
      </div>
    </div>

    <!-- 修改密码弹窗 -->
    <div v-if="showChangePwdDialog" class="dialog-overlay" @click.self="closeChangePwdDialog">
      <div class="dialog-content">
        <div class="dialog-header">
          <h3>修改密码</h3>
          <button class="close-btn" @click="closeChangePwdDialog">×</button>
        </div>
        <div class="dialog-body">
          <div class="form-group">
            <label>新密码：</label>
            <input type="password" v-model="newPassword" placeholder="请输入新密码" class="form-control">
          </div>
          <div class="form-group">
            <label>确认密码：</label>
            <input type="password" v-model="confirmPassword" placeholder="请再次输入新密码" class="form-control">
            <span v-if="passwordError" class="error-message">{{ passwordError }}</span>
          </div>
        </div>
        <div class="dialog-footer">
          <button @click="closeChangePwdDialog" :disabled="updating">取消</button>
          <button @click="confirmChangePassword" :disabled="updating" class="confirm-btn">
            {{ updating ? '修改中...' : '确认' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 导航栏组件 - 提供左侧导航菜单和右侧内容显示区域
 * 功能：
 * - 显示导航菜单
 * - 点击菜单项加载对应URL到iframe
 * - 处理页面加载错误
 */

 // 导入MD5加密函数
import { md5 } from '@/utils/md5.js';

export default {
  name: 'NavBar',
  data() {
    return {
      loginUser: {
        name: "",
        uid: null,
      },
      // 下拉菜单状态
      showDropdown: false,
      // 修改密码弹窗状态
      showChangePwdDialog: false,
      // 密码数据
      newPassword: '',
      confirmPassword: '',
      passwordError: '',
      updating: false,
      // 导航菜单项配置
      navItems: [],
      // 当前选中的菜单项索引
      currentIndex: 0,
      // 当前页面标题
      currentTitle: ''
    }
  },
  mounted() {
    this.axios.get('/data-serv/user/info')
      .then(res => {
        console.log(res.data);
        if (res.data.code === 0) {
          console.log("save userInfo", JSON.stringify(res.data.data));
          localStorage.setItem("userInfo", JSON.stringify(res.data.data));
          // 用户信息更新后，重新构建菜单
          this.buildNavMenu();
        }
      })
      .catch(error => {
        console.error('获取用户信息失败:', error);
        // 即使获取失败，也尝试构建基础菜单
        this.buildNavMenu();
      });
    
    // 如果本地已有用户信息，也构建菜单
    if (localStorage.getItem('userInfo')) {
      this.loginUser = JSON.parse(localStorage.getItem('userInfo'));
      this.buildNavMenu();
    }
  },
  methods: {
    /**
     * 根据用户权限构建导航菜单
     */
    buildNavMenu() {
      const baseMenu = [];

      // 检查用户权限
      
      const userInfoStr = localStorage.getItem('userInfo');
      if (userInfoStr) {
        try {
          const userInfo = JSON.parse(userInfoStr);
          
          // 如果有权限，添加用户管理菜单
          if (userInfo.isAdmin) {
            baseMenu.push({ name: '用户管理', url: '/nav-bar/user-manage' });
          }

          if (userInfo.isAdmin || userInfo.roleType === 1) {
            baseMenu.push({ name: '产品首页', url: '/nav-bar/product-ranks' });
            baseMenu.push({ name: '产品管理', url: '/nav-bar/product-index' });
          }

          baseMenu.push({ name: '订单管理', url: '/nav-bar/order-list' });
          baseMenu.push({ name: '单品签收率', url: '/nav-bar/sign-rate' });
          baseMenu.push({ name: '个人签收率', url: '/nav-bar/person-rate' });
          baseMenu.push({ name: '个人单品签收率', url: '/nav-bar/person-single-rate' });
          baseMenu.push({ name: '公司货盘管理', url: '/nav-bar/inventory-list' });
          baseMenu.push({ name: '自发货盘管理', url: '/nav-bar/inventory-list-self' });
          
          if (userInfo.isAdmin) {
          }

        } catch (error) {
          console.error('解析用户信息失败:', error);
        }
      }

      this.navItems = baseMenu;

      // 设置当前标题和索引
      if (this.navItems && this.navItems.length > 0) {
        this.currentTitle = this.navItems[0].name;
        // 检查当前路由是否在导航项中，如果是则更新当前索引
        const currentPath = this.$route.path;
        const currentItemIndex = this.navItems.findIndex(item => item.url === currentPath);
        if (currentItemIndex !== -1) {
          this.currentIndex = currentItemIndex;
        } else {
          this.currentIndex = 0;
        }
      }
    },

    /**
     * 导航到指定菜单项
     * @param {Object} item - 菜单项对象
     * @param {number} index - 菜单项索引
     */
    navigateTo(item, index) {
      // 更新活动状态
      this.currentIndex = index
      this.currentTitle = item.name

      // 使用路由跳转整个窗口
      this.$router.push(item.url)
    },

    logout() {
      // 移除本地用户登录信息
      localStorage.removeItem('userInfo');
      localStorage.removeItem('token');
      // 跳转页面到登录页
      this.$router.push('/login');
    },

    // 切换下拉菜单显示状态
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },

    // 打开修改密码弹窗
    changePassword() {
      this.showDropdown = false;
      this.showChangePwdDialog = true;
      this.newPassword = '';
      this.confirmPassword = '';
      this.passwordError = '';
    },

    // 关闭修改密码弹窗
    closeChangePwdDialog() {
      this.showChangePwdDialog = false;
      this.newPassword = '';
      this.confirmPassword = '';
      this.passwordError = '';
    },

    // 确认修改密码
    confirmChangePassword() {
      // 验证密码
      if (!this.newPassword) {
        this.passwordError = '请输入新密码';
        return;
      }

      if (this.newPassword !== this.confirmPassword) {
        this.passwordError = '两次输入的密码不一致';
        return;
      }

      // 调用API修改密码
      this.updating = true;

      const requestData = {
        password: md5(this.newPassword),
        confirmPassword: md5(this.confirmPassword)
      };

      this.axios.post('/data-serv/user/update-passwd', requestData)
        .then(response => {
          if (response.data.code === 0) {
            // 显示成功提示
            if (this.$message) {
              this.$message.success('密码修改成功');
            }

            // 关闭弹窗
            this.closeChangePwdDialog();
          } else {
            throw new Error(response.data.msg || '密码修改失败');
          }
        })
        .catch(error => {
          console.error('修改密码失败:', error);
          // 显示错误提示
          if (this.$message) {
            this.$message.error(error.message || '密码修改失败');
          }
        })
        .finally(() => {
          this.updating = false;
        });
    }
  }
}
</script>

<style scoped>
.nav-container {
  display: flex;
  height: 100vh;
  font-family: Arial, sans-serif;
}

/* 左侧导航栏样式 */
.sidebar {
  width: 200px;
  background-color: #2c3e50;
  color: white;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
}

.logo {
  padding: 10px 20px;
  border-bottom: 1px solid #34495e;
}

.user-info {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-dropdown {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.user-dropdown:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.user-info h4 {
  margin: 0;
  color: white;
  margin-right: 5px;
}

.dropdown-arrow {
  font-size: 12px;
  color: white;
  margin-left: 5px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  color: #333;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 150px;
  z-index: 1000;
  margin-top: 5px;
}

.dropdown-header {
  padding: 10px 15px;
  border-bottom: 1px solid #eee;
  font-weight: bold;
}

.dropdown-option {
  padding: 10px 15px;
  transition: background-color 0.2s;
}

.dropdown-item {
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.dropdown-item.logout-item {
  color: #e74c3c;
}

.dropdown-item.logout-item:hover {
  background-color: #ffebee;
}

.logout-btn {
  color: white;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 5px;
  transition: background-color 0.3s;
  border-radius: 4px;
}

.logout-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.power-icon {
  font-size: 16px;
}

.nav-menu {
  list-style: none;
  flex-grow: 1;
  overflow-y: auto;
  padding: 0;
  margin: 0;
}

.nav-menu li {
  padding: 15px 20px;
  cursor: pointer;
  transition: background-color 0.3s;
  border-bottom: 1px solid #34495e;
}

.nav-menu li:hover {
  background-color: #34495e;
}

.nav-menu li.active {
  background-color: #1abc9c;
}

/* 右侧内容区域样式 */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 200px;
}

.page-header {
  padding: 15px 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.page-container {
  flex: 1;
  position: relative;
  overflow-y: auto;
  height: 100%;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.empty-state {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  background-color: #f8f9fa;
}

/* 修改密码弹窗样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.dialog-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dialog-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dialog-header h3 {
  margin: 0;
  font-size: 18px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  color: #666;
}

.dialog-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
}

.form-control:focus {
  outline: none;
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.error-message {
  color: #f5222d;
  font-size: 12px;
  margin-top: 5px;
  display: block;
}

.dialog-footer {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.dialog-footer button {
  padding: 6px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.dialog-footer button:first-child {
  background-color: white;
  border: 1px solid #d9d9d9;
  color: #666;
}

.dialog-footer button:first-child:hover:not(:disabled) {
  border-color: #40a9ff;
  color: #40a9ff;
}

.confirm-btn {
  background-color: #1890ff;
  border: 1px solid #1890ff;
  color: white;
}

.confirm-btn:hover:not(:disabled) {
  background-color: #40a9ff;
  border-color: #40a9ff;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>